// import external dependencies
import 'jquery';
import 'chart.js/dist/Chart';
import 'slick-carousel';
import 'svgxuse/svgxuse';
import 'tabslet/jquery.tabslet';
import 'masonry-layout/dist/masonry.pkgd';
import 'stellar.js/jquery.stellar';

// Import everything from autoload
import './autoload/jquery.fancybox.min.js';
import './myscripts';
import './blocks/video-review';
import './blocks/faq';
// import local dependencies
// import Router from './util/Router';
// import common from './routes/common';
// import home from './routes/home';
// import aboutUs from './routes/about';

// /** Populate Router instance with DOM routes */
// const routes = new Router({
//   // All pages
//   common,
//   // Home page
//   home,
//   // About Us page, note the change from about-us to aboutUs.
//   aboutUs,
// });

// // Load Events
// jQuery(document).ready(() => routes.loadEvents());
// alert('smth');



// WEBPACK FOOTER //
// ./scripts/main.js